'use client';

import { useState } from 'react';

import Image from 'next/image';

/**
 * Logo zone of a customer card. Falls back to the initial-letter placeholder
 * (ported from the old /flow/customers showcase) when the client has no local
 * asset or the image fails to load; external URLs are never hotlinked.
 */
export function CustomerLogo({
  name,
  src,
}: {
  name: string;
  src: string | null;
}) {
  const [imageFailed, setImageFailed] = useState(false);

  if (!src || imageFailed) {
    return (
      <div
        className="flex h-16 w-16 items-center justify-center rounded-full bg-[#ede8e2]"
        aria-hidden="true"
      >
        <span
          className="font-roboto text-[26px] leading-none text-[#2b2b2b]"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {name.charAt(0)}
        </span>
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={`${name} logo`}
      width={220}
      height={100}
      className="max-h-[96px] w-auto max-w-[75%] rounded-[12px] object-contain transition-transform duration-300 group-hover:scale-[1.05]"
      unoptimized
      onError={() => setImageFailed(true)}
    />
  );
}
